/**
 * @ External Dependecies
 */
import styled from 'styled-components';

/**
 * @ Internal Dependecies
 */
import colors from 'shared/constants/colors';
import device from 'shared/constants/sizing';

const ProfileWidget = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content min-content;
  float: right;
`;

export const ProfileWidgetHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 10px;

  ${(props) =>
    props.borderleft &&
    `
		border-left: 1px solid rgba(151, 151, 151, 0.15);
  `};

  @media ${device.medium} {
    min-width: 80px;
    min-height: 70px;
    padding: 0px 20px;
  }
`;

export const ProfileWidgetGivenName = styled.span`
  color: ${colors.midnight};
  margin-right: 10px;
  display: none;

  @media ${device.medium} {
    display: block;
  }
`;

export const ProfileWidgetAvatar = styled.button`
  width: 36px;
  height: 36px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-color: #d8d8d8;
  border-radius: 50%;
  overflow: hidden;
  border: none;
  font-weight: 900;
`;

export const ProfileWidgetNotification = styled.button`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  background: none;
  border: none;

  span {
    position: absolute;
    right: -3px;
    top: -5px;
  }
`;

export const ProfileWidgetCount = styled.span`
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid ${colors.cotton};
  background: ${colors.midnight};
  font-size: 0px;
  line-height: 0px;
  text-align: center;
  color: ${colors.cotton};
`;

export const ProfileMenuAccount = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  background-color: #1c1c1c;
  color: ${colors.cotton};
  padding: 20px;
`;

export const ProfileMenuButton = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  padding: 10px 20px;
  background-color: ${colors.cotton};

  &:hover {
    background-color: ${colors.midnight};
    color: ${colors.cotton};
  }
`;

export default ProfileWidget;
